// @ts-ignore
import { env as _env } from "fastly:env";
import { NotSupportedError } from "../error.ts";
export * from "../runtime.ts";
export { default } from "../runtime.ts";
export function env(name = undefined, value = undefined) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (typeof name === "object" || value !== undefined) {
        throw new NotSupportedError("Cannot modify environment variables in the worker.");
    }
    else if (name === undefined) {
        return {
            "FASTLY_CACHE_GENERATION": (_a = _env("FASTLY_CACHE_GENERATION")) !== null && _a !== void 0 ? _a : "",
            "FASTLY_CUSTOMER_ID": (_b = _env("FASTLY_CUSTOMER_ID")) !== null && _b !== void 0 ? _b : "",
            "FASTLY_HOSTNAME": (_c = _env("FASTLY_HOSTNAME")) !== null && _c !== void 0 ? _c : "",
            "FASTLY_POP": (_d = _env("FASTLY_POP")) !== null && _d !== void 0 ? _d : "",
            "FASTLY_REGION": (_e = _env("FASTLY_REGION")) !== null && _e !== void 0 ? _e : "",
            "FASTLY_SERVICE_ID": (_f = _env("FASTLY_SERVICE_ID")) !== null && _f !== void 0 ? _f : "",
            "FASTLY_SERVICE_VERSION": (_g = _env("FASTLY_SERVICE_VERSION")) !== null && _g !== void 0 ? _g : "",
            "FASTLY_TRACE_ID": (_h = _env("FASTLY_TRACE_ID")) !== null && _h !== void 0 ? _h : "",
        };
    }
    return _env(name);
}
//# sourceMappingURL=runtime.js.map